// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__natqF","icon":"footer_icon__wqTFr","links":"footer_links__bx-2i"};